/**
 * MachineFeedback — отзывы покупателей на странице машины: итог за 30 дней
 * и последние отзывы (плохие с причиной).
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFeedback, type FeedbackReview, type FeedbackTotals } from '../api/client';
import { FeedbackBar, RatingBadge, reasonLabel } from './FeedbackBar';

export function MachineFeedback({ machineId }: { machineId: number }) {
  const [reviews, setReviews] = useState<FeedbackReview[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    // includeSandbox не нужен: страница песочницы покажет пусто, и это честно.
    getFeedback({ days: 30, machineId, limit: 500 })
      .then((r) => { if (alive) { setReviews(r); setError(null); } })
      .catch((e) => { if (alive) setError(e instanceof Error ? e.message : 'Failed to load reviews'); });
    return () => { alive = false; };
  }, [machineId]);

  const totals: FeedbackTotals = { good: 0, ok: 0, bad: 0, total: 0 };
  for (const r of reviews ?? []) { totals[r.rating]++; totals.total++; }

  return (
    <div className="card mb-6">
      <div className="card-header flex items-center justify-between">
        <span>Customer Reviews · 30 days</span>
        <Link to={`/feedback?machine=${machineId}`} style={{ fontSize: '0.85rem', fontWeight: 400 }}>All reviews →</Link>
      </div>
      <div className="card-body">
        {error ? (
          <p style={{ color: 'var(--color-offline)' }}>Error: {error}</p>
        ) : reviews === null ? (
          <p className="text-muted">Loading…</p>
        ) : reviews.length === 0 ? (
          <p className="text-muted">No reviews in the last 30 days.</p>
        ) : (
          <>
            <FeedbackBar totals={totals} />
            <div className="table-wrapper" style={{ marginTop: 16 }}>
              <table>
                <tbody>
                  {reviews.slice(0, 10).map((r) => (
                    <tr key={r.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{new Date(r.at).toLocaleString()}</td>
                      <td><RatingBadge rating={r.rating} /></td>
                      <td>{r.rating === 'bad' ? reasonLabel(r.reason) : ''}</td>
                      <td className="text-muted" style={{ whiteSpace: 'nowrap' }}>
                        {r.code ? <Link to={`/sessions?code=${r.code}`}>{r.code}</Link> : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
